/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  FeedbackError,
  FeedbackRequest,
  FeedbackSubmitted
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type feedbackCreateResponse200 = {
  data: FeedbackSubmitted
  status: 200
}

export type feedbackCreateResponse500 = {
  data: FeedbackError
  status: 500
}

export type feedbackCreateResponseSuccess = (feedbackCreateResponse200) & {
  headers: Headers;
};
export type feedbackCreateResponseError = (feedbackCreateResponse500) & {
  headers: Headers;
};

export type feedbackCreateResponse = (feedbackCreateResponseSuccess | feedbackCreateResponseError)

export const getFeedbackCreateUrl = () => {




  return `/api/v1/feedback/`
}

/**
 * Submit feedback
 */
export const feedbackCreate = async (feedbackRequest: FeedbackRequest, options?: RequestInit): Promise<feedbackCreateResponse> => {

  return customFetch<feedbackCreateResponse>(getFeedbackCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(feedbackRequest)
  }
);}


